import React, { useRef, useState } from 'react';
import { defaultPickUpDate, defaultPickUpTime, defaultDropOffDate, defaultDropOffTime, getTodayDate, timeOptions, triggerDatePicker, getAfterDayDate, calculateHourDifference, isValidPickup } from '../../functionsMaster';
// import { Link } from 'react-router-dom';
import Select from 'react-select';
import PickLocationSelect from './pickLocationSelect';
import PropTypes from 'prop-types';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

// const SearchForm = ({ landedOn = 'listCar', message = "", setMessage = () => { alert("Not Defined"); } }) => {
const SearchForm = ({
  landedOn = 'listCar',
  message = { status: 0, value: "" },
  setMessage = (msg : { status: 0, value: "" }) => console.warn("setMessage not provided:", msg)
}) => {
  const inputPickupDate = useRef(null);
  const inputReturnDate = useRef(null);

  const [listPickTimeOpen, setListPickTimeOpen] = useState(false);
  const [listRerurnTimeOpen, setListRerurnTimeOpen] = useState(false);

  const [pickUpDate, setPickUpDate] = useState(defaultPickUpDate());
  const [pickUpTime, setPickUpTime] = useState(defaultPickUpTime());
  const [dropOffDate, setDropOffDate] = useState(defaultDropOffDate());
  const [dropOffTime, setDropOffTime] = useState(defaultDropOffTime());

  // Utility to detect mobile device
  const isMobileDevice = () => {
    return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  };
  // === Handle Pickup Date Selection ===
  const handlePickUpDateChange = (value = '') => {
    setPickUpDate(value);
    localStorage.setItem('filPickUpDate', value);
    // Only open time select on non-mobile devices
    if (!isMobileDevice()) {
      setListPickTimeOpen(true);
    }
  };

  // === Handle Pickup Time Selection ===
  const handlePickUpTimeChange = (value = '') => {
    setPickUpTime(value);
    localStorage.setItem('filPickUpTime', value || '');
  };

  // === Handle Drop-off Date Selection ===
  const handleDropOffDateChange = (value = '') => {
    setDropOffDate(value);
    localStorage.setItem('filDropOffDate', value);
    // Only open time select on non-mobile devices
    if (!isMobileDevice()) {
      setListRerurnTimeOpen(true);
    }
  };

  // === Handle Drop-off Time Selection ===
  const handleDropOffTimeChange = (value = '') => {
    setDropOffTime(value);
    localStorage.setItem('filDropOffTime', value || '');
  };

  function changeFunctionLocation() {
    triggerDatePicker(inputPickupDate)
  }

  function submitFormCheck(e) {
    // console.log(`
    //     pickUpDate: ${pickUpDate} 
    //     pickUpTime: ${pickUpTime} 
    //     dropOffDate: ${dropOffDate} 
    //     dropOffTime: ${dropOffTime} 
    // `);

    if (!isValidPickup(pickUpDate, pickUpTime)) {
      e.preventDefault();
      setMessage({ status: 0, value: 'Selected pickup date and time is not valid. Please choose a future time.' });
    }

    const v = calculateHourDifference( pickUpDate, pickUpTime, dropOffDate, dropOffTime, 'ceil');
    if (v < 24) {
      e.preventDefault();
      setMessage({ status: 0, value: 'Sorry! The minimum booking duration is 24 hours.' });
    }

    return true;
  }

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor:
        state.isSelected
          ? "#4caf50" // selected option color
          : state.isFocused
            ? "#e8f5e9" // hover color
            : state.data.__index % 2 === 0
              ? "#ffffff" // even rows
              : "#f7f7f7", // odd rows (zebra)
      color: "#333",
      cursor: "pointer",
    }),
  };

  return (
    <div className="section-search">
      <div className={landedOn === "home" ? "" : "container"}>
        <div className="search-box-banner" style={{ background: "transparent", zIndex: 999999 }}>
          <form
            action="/listings/cars"
            onSubmit={(e) => {
              submitFormCheck(e);
            }}
          >
            <div className="row">

              <div className={landedOn === "home" ? "col-md-6 mt-3" : "col-md-2 mt-3"}>
                <div className="form-group">
                  <b className={landedOn === "home" ? "text-white" : ""}>Pickup Date</b>
                  <DatePicker
                    required
                    style={{ width: '100%' }}
                    selected={pickUpDate}
                    onChange={(date) => handlePickUpDateChange(date)}
                    onInputClick={() => {
                      setListPickTimeOpen(false);
                      setListRerurnTimeOpen(false);
                    }}
                    dateFormat="dd/MM/yy"
                    className="form-control"
                    minDate={getTodayDate()}
                    maxDate={new Date(new Date().setDate(new Date().getDate() + 90))}
                    placeholderText="dd/mm/yy"
                  />
                </div>
              </div>

              <div className={landedOn === "home" ? "col-md-6 mt-3" : "col-md-2 mt-3"}>
                <div className="form-group">
                  <b className={landedOn === "home" ? "text-white" : ""}>Pickup Time</b>
                  <Select
                    required
                    styles={customStyles}
                    isSearchable={false}    // 👈 prevents typing / keyboard
                    menuIsOpen={listPickTimeOpen}
                    options={timeOptions}
                    placeholder="Select Pickup Time"
                    className="basic-single"
                    style={{ width: '100%' }}
                    classNamePrefix="select"
                    defaultValue={timeOptions.find(option => option.value === pickUpTime)}
                    onMenuOpen={() => setListPickTimeOpen(true)}   // opens on click/focus
                    onMenuClose={() => setListPickTimeOpen(false)} // closes when user clicks outside
                    onChange={(selectedOption) => {
                      handlePickUpTimeChange(selectedOption?.value);
                      triggerDatePicker(inputReturnDate);
                      setListPickTimeOpen(false);
                    }}
                  />
                </div>
              </div>

              <div className={landedOn === "home" ? "col-md-6 mt-3" : "col-md-2 mt-3"}>
                <div className="form-group">
                  <b className={landedOn === "home" ? "text-white" : ""}>Return Date</b>
                  <DatePicker
                    required
                    style={{ width: '100%' }}
                    selected={dropOffDate}
                    onInputClick={() => {
                      setListPickTimeOpen(false);
                      setListRerurnTimeOpen(false);
                    }}
                    onChange={(date) => handleDropOffDateChange(date)}
                    dateFormat="dd/MM/yy"
                    className="form-control"
                    minDate={pickUpDate}
                    maxDate={getAfterDayDate(120)}
                    placeholderText="dd/mm/yy"
                  />
                </div>
              </div>

              <div className={landedOn === "home" ? "col-md-6 mt-3" : "col-md-2 mt-3"}>
                <div className="form-group">
                  <b className={landedOn === "home" ? "text-white" : ""}>Return Time</b>
                  <Select
                    required
                    styles={customStyles}
                    isSearchable={false}    // 👈 prevents typing / keyboard
                    menuIsOpen={listRerurnTimeOpen}
                    options={timeOptions}
                    placeholder="Select Return Time"
                    className="basic-single"
                    classNamePrefix="select"
                    defaultValue={timeOptions.find(option => option.value === dropOffTime)}
                    onMenuOpen={() => setListRerurnTimeOpen(true)}   // opens on click/focus
                    onMenuClose={() => setListRerurnTimeOpen(false)} // closes when user clicks outside
                    onChange={(selectedOption) => {
                      handleDropOffTimeChange(selectedOption?.value);
                      setListRerurnTimeOpen(false);
                    }}
                  />
                </div>
              </div>


              <div className={landedOn === "home" ? "col-md-6 mt-3" : "col-md-2 mt-3"}>
                <div className="form-group">
                  <b className={landedOn === "home" ? "text-white" : ""}>Pickup Location</b>
                  <PickLocationSelect changeFunction={changeFunctionLocation} />
                </div>
              </div>

              <div className={landedOn === "home" ? "col-md-6 mt-3" : "col-md-2 mt-3"}>
                <div className="form-group">
                  <b>&nbsp;</b>
                  <br />
                  <button
                    type="submit"
                    className="btn btn-warning w-100"
                  >
                    <i className="fa fa-search" aria-hidden="true" /> Search
                  </button>
                </div>
              </div>

              {message.value && message.value !== '' && (
                <div className="col-md-12 mt-3">
                  <div className={`alert alert-${message.status ? 'success' : 'danger'}`}>
                    {message.value}
                  </div>
                </div>
              )}

            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

SearchForm.propTypes = {
  landedOn: PropTypes.any,
  message: PropTypes.any,
  setMessage: PropTypes.any,
};

export default SearchForm;
